export default __webpack_public_path__ + "static/media/vk.ec1d95c2.svg";